import React from 'react';

import type { Section } from '../../../../../models';
import { HEATING_OIL } from '../../../../../constants';
import DeliveredToAreasOtherThanTenantsUnit from '../../DeliveredToAreasOtherThanTenantsUnit';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function HeatingOilDelivered({ section, setSectionValues }: Props): JSX.Element {
  return (
    <DeliveredToAreasOtherThanTenantsUnit
      section={section}
      setSectionValues={setSectionValues}
      deliveredToAreasOtherThanTenantsUnitField={HEATING_OIL.FIELD_NAME.DELIVERED_TO_AREAS_OTHER_THAN_TENANTS_UNIT}
      utilityName="Heating oil"
    />
  );
}

HeatingOilDelivered.description = 'Yes/no on whether service/utility is devliered to area other than tenants unit';

export default HeatingOilDelivered;
